import React, { Component } from "react";
import { Row, Col, Tooltip } from "antd";
import { mergeApiHandle } from "./connector";
import Preloader from "../../../../CommonComponents/Preloader/Preloader";
import { withRouter } from "react-router-dom";
import { initiateTracking, formatAmount, formatShares, recordError } from "../../../../utils/commonUtil";
import { fetchInvestmentOptionData, processedDataFetch } from "./action";
import { connect } from "react-redux";
import moment from "moment";
import * as _ from 'lodash'
import PropTypes from 'prop-types';
import {
  FixedWidth,
  PagesHeading,
  DataValue,
  SectionLastHeading,
  DisplayFlex,
  DataHeading,
  StyleLessButton
} from "../../../../CommonComponents/commonStyles";
import InvestmentOptionDetailsWeb from "./InvestmentOptionDetailsWeb";
import TabsComponent from "../../../../CommonComponents/TabsComponent/TabsComponent";
import BreadcrumbComponent from "../../../../CommonComponents/Breadcrumb/Breadcrumb";
import PrintComponents from "react-print-components";
import {
  InvestmentOption,
  UnderlyingFund,
  DataHead,
  DivHeading,
  PIPWrapper,
  IconsPlace,
  IconsPlaceNew,
  IconPadding,
  DataExportPrint,
  UnderlyingFundParagraph,
  DownloadIcon,
  ReportIcon,
  UnderlyingContent
} from "./styles";
import { startDate, todayDate } from "../../../../utils/commonUtil";
import printIcon from "../../../../assets/icons/print.svg";
import EyeIcon from "../../../../assets/icons/eye-icon.svg";
import { getPrimaryAccount } from "../../../../utils/sessionUtil";
import exportIcon from "../../../../assets/icons/export.svg";
import { ContentProvider, ContentMessage, Types } from "../../../../CommonComponents/ContentMessages";
import { investmentOptionDerivedStates } from "./selectors";
import GlobalModal from "../../../../CommonComponents/AlertModal/GlobalModal";
import { replaceSelect } from "../../../../utils/replacer";
import { exportExcelTableData } from "../../../../services/apiServices";
let myInvestmentColumns = [
  {
    title: "Investment Option",
    dataIndex: "investmentOption",
    key: "investmentOption"
  },
  {
    title: "Current Balance",
    dataIndex: "currentBalance",
    key: "currentBalance"
  },
  {
    title: "Available Units",
    dataIndex: "availableUnits",
    key: "availableUnits"
  },
  {
    title: "Expense Ratio",
    dataIndex: "selExpRatio",
    key: "selExpRatio"
  },
  {
    title: "Current NAV",
    dataIndex: "currentNAV",
    key: "currentNAV"
  }
];

let columns = [
  {
    title: "Investment Option",
    dataIndex: "investmentOption",
    key: "investmentOption"
  },
  {
    title: "Returns Qtr",
    dataIndex: "returnsYTD",
    key: "returnsYTD"
  },
  {
    title: "1 Year",
    dataIndex: "oneY",
    key: "oneY"
  },
  {
    title: "5 Year",
    dataIndex: "fiveY",
    key: "fiveY"
  },
  {
    title: "10 Year",
    dataIndex: "tenY",
    key: "tenY"
  },
  {
    title: "Expense Ratio",
    dataIndex: "selExpRatio",
    key: "selExpRatio"
  },
  {
    title: "Current NAV",
    dataIndex: "currentNAV",
    key: "currentNAV"
  }
];


export { myInvestmentColumns, columns };

export const tabConfig = function destObj(
  data,
  columnConfig,
  expandConfig,
  options = "true",
  findExpanded,
  getPageTitle,
  exportDataUpdate
) {
 return [
    {
      render: (
        <InvestmentOptionDetailsWeb
          tabName={"My Investments"}
          fundData={data}
          columnConfig={columnConfig}
          expandConfig={expandConfig}
          options={options}
          findExpanded={findExpanded}
          getPageTitle={getPageTitle}
          exportDataUpdate={exportDataUpdate}
        />
      )
    },
    {
      render: (
        <InvestmentOptionDetailsWeb
          tabName={"Portfolio Solutions"}
          fundData={data}
          columnConfig={columnConfig}
          expandConfig={expandConfig}
          options={options}
          findExpanded={findExpanded}
          getPageTitle={getPageTitle}
          exportDataUpdate={exportDataUpdate}
        />
      )
    },
    {
      render: (
        <InvestmentOptionDetailsWeb
          tabName={"Portfolio Builders"}
          fundData={data}
          columnConfig={columnConfig}
          expandConfig={expandConfig}
          options={options}
          findExpanded={findExpanded}
          getPageTitle={getPageTitle}
          exportDataUpdate={exportDataUpdate}
        />
      )
    },
    {
      render: (
        <InvestmentOptionDetailsWeb
          tabName={"Values-driven Investments"}
          fundData={data}
          columnConfig={columnConfig}
          expandConfig={expandConfig}
          options={options}
          findExpanded={findExpanded}
          getPageTitle={getPageTitle}
          exportDataUpdate={exportDataUpdate}
        />
      )
    }
  ];
};

class InvestmentOptionDetails extends Component {
  constructor(props) {
    super(props);
    this.pageTitle = "Investment option details";
    this.state = {
      OptionData: [],
      isLoading: true,
      printData: [],
      exportData: [],
      tabIndex: 1,
      enableScroll: false,
      exportwithSortedData: {}
    };
  }
  exportExcel = () => {
    let fileName, tabIdentifier, data;
    switch (this.state.tabIndex.toString()) {
      case "1": 
              fileName = 'My Investments';
              tabIdentifier = "myInvestments";
              data = this.state.exportwithSortedData.MI
              break;
      case "2": 
              fileName = 'Portfolio Solutions';
              tabIdentifier = "portfolioSolutions";
              data = this.state.exportwithSortedData.PS
              break;
      case "3":  
              fileName ='Portfolio Builders';
              tabIdentifier = "portfolioBuilders";
              data = this.state.exportwithSortedData.PB
              break;
      default:  
              fileName ='Values-driven Investments';
              tabIdentifier = "valuesDrivenInvestments";
              data = this.state.exportwithSortedData.VDI
              break;
    }
    this.analyticsTracking("Export", fileName)
    let url = `/donor-portal/api/investmentOptions/${getPrimaryAccount().userId}/exportInvestmentOptionDetails`;
    return exportExcelTableData(url, { tab: tabIdentifier, transactions: data }, fileName);
    
  }
  setPageTitle = (title = '') => {
    if(title) {
      this.pageTitle = title;
    }
  }

  getPageTitle = () => {
    return this.pageTitle;
  }

  exportDataUpdate = (data) => {
    let tabNames;
    switch(this.state.tabIndex){
      case "1": 
            tabNames="MI";
            break;
      case "2": 
            tabNames="PS";
            break;
      case "3": 
            tabNames="PB";
            break;
      case "4":
            tabNames="VDI";
            break;
     default:
            tabNames="MI";
            break;
     }
     this.setState((prevState)=>({ 
      exportwithSortedData: {
        ...prevState.exportwithSortedData,         
        [tabNames]: data
      } 
    }))
  }

  modifyAnchorTag(url) {
    let tempArray = [];
    let urlArray = url.split(" ");
    let temp = urlArray[1].replace('href="', "");
    let newTemp = temp.slice(0, -1);
    tempArray.push(newTemp);
    urlArray.splice(1, 1);
    if (!url.includes("Benchmark Return")) {
      urlArray.splice(1, 0, 'href="javascript:void(0)"');
    }
    tempArray.push(urlArray.join(" "));
    return tempArray;
  }
  getAlert(link) {
    try {
      GlobalModal({ 
        handleOk: ()=>{ window.open(link, "_blank")}, 
        contents: "Clicking OK will open a new window to Vanguard.com, a website that is not hosted by Vanguard Charitable.",
        type: "confirm"
      });
    } catch (error) {      
      recordError(error);
    }
  }

  getTabNameWithIndex(index){
    switch (index) {
      case "1": return 'My Investments';
      case "2": return 'Portfolio Solutions';
      case "3": return 'Portfolio Builders';
      default: return 'Values-driven Investments';
    }
  }

  analyticsTracking(buttonName,tabName) {
    try {
      if (buttonName === "Export") {
        initiateTracking("export", this.getPageTitle(), tabName, buttonName);
        return 'export';
      }
      if (buttonName === "Print") {
        initiateTracking("print", this.getPageTitle(), this.getTabNameWithIndex(tabName), buttonName);
        return 'print';
      }
    } catch (error) {          
      recordError(error);      
    }
  }

  componentDidMount() {
    this.props.requestData({
      metaData: [
        {
          method: "GET",
          url: `/donor-portal/api/investmentOptions/findInvestmentOptionsByAccountIdFromDateAndToDate?accountId=${
            getPrimaryAccount().userId
          }&fromDate=${startDate(90)}&toDate=${todayDate()}&isIOD=true`,
          page: "investmentOptionDetails"
        },
        {
          method: "GET",
          url: `/donor-portal/api/investment/${
            getPrimaryAccount().userId
          }/findMyInvestmentsByAccountId?startDateStr=${startDate(
            90
          )}&endDateStr=${todayDate()}`,
          page: "investmentOptionDetails"
        },
        {
          method: "GET",
          url: `/investment-api-funds/`,
          page: "investmentOptionDetails",
          isExternal: true
        },
        {
          method: "GET",
          url: `/investment-underlying-funds-api/`,
          page: "investmentOptionDetails",
          isExternal: true
        },
        {
          method: "GET",
          url: `/quarterly-investment-performance`,
          page: "investmentOptionDetails",
          isExternal: true
        }
      ]
    });

    window.scrollTo(0, 0); 

    if (window.innerWidth <= 767) this.setState({ enableScroll: true });
    else if (window.innerWidth > 767) this.setState({ enableScroll: false });   

    window.addEventListener("resize", this.handleResize);
  }

  handleResize = (e) => {
    if (e.currentTarget.innerWidth <= 767) {
      if (this.state.enableScroll === false) {
        this.setState({ enableScroll: true });
      }
    } else if (e.currentTarget.innerWidth > 767) {
      if (this.state.enableScroll === true) {
        this.setState({ enableScroll: false });
      }
    }
  }

  componentWillMount() {
    const params = this.props.location.state;
    const tabIndex =
      params && params.hasOwnProperty("tabIndex") ? params.tabIndex : 1;
    if (tabIndex >= 0) this.setState({ tabIndex: tabIndex });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", () => {});
  }

  componentWillReceiveProps(nextProps) {
    let optionData = -1;
    
    if (
      !nextProps.isLoadingDrupal &&
      !nextProps.isMyLoadingUST &&
      !nextProps.isLoadingUST &&
      !nextProps.isLoadingUnderlying
    ) {
      optionData = mergeApiHandle(
        nextProps.investmentDrupal,
        nextProps.underlyingDrupal,
        nextProps.investmentUST,
        nextProps.myInvestmentUST
      );     

      this.checkEnableScroll(optionData, this.state.tabIndex);
    }

    this.setState(
      {
        OptionData: optionData,
        isLoading: false
      }
    );

    if (nextProps.accountID !== this.props.accountID) {
      this.props.history.push("/");
    }
  }

  checkEnableScroll(optionData, tabIndex) {
    let a = optionData.fundData.tab2.findIndex(
      item => item.isMyInvestment === true
    );

    let b = optionData.fundData.tab3.findIndex(
      item => item.isMyInvestment === true
    );

    let c = optionData.fundData.tab4.findIndex(
      item => item.isMyInvestment === true
    );

    if (a === -1 && b === -1 && c === -1 && this.state.tabIndex.toString() === "1")
      this.setState({ enableScroll: false });

    if (tabIndex.toString() === "2" && optionData.fundData.tab2.length === 0)
      this.setState({ enableScroll: false });

    if (tabIndex.toString() === "3" && optionData.fundData.tab3.length === 0)
      this.setState({ enableScroll: false });

    if (tabIndex.toString() === "4" && optionData.fundData.tab4.length === 0)
      this.setState({ enableScroll: false });
  }

  addUnitSymbols(exportData) {
    exportData = JSON.parse(JSON.stringify(exportData));
    let tabItem = exportData.map(item1 => {
      let item =  _.cloneDeep(item1)
      item.investmentOption = item.investmentOption && item.investmentOption.replace(" Select","")
      item.currentBalance = item.currentBalance
        ? formatAmount(item.currentBalance)
        : "";
      item.availableUnits = item.availableUnits
        ? formatShares(item.availableUnits)
        : "";

      item.selExpRatio = item.selExpRatio ? `${item.selExpRatio}%` : "";
      item.stdExpRatio = item.stdExpRatio ? `${item.stdExpRatio}%` : "";
      item.returnsYTD = item.returnsYTD ? `${item.returnsYTD}%` : "";
      item.oneY = item.oneY ? `${item.oneY}%` : "";
      item.fiveY = item.fiveY ? `${item.fiveY}%` : "";
      item.tenY = item.tenY ? `${item.tenY}%` : "";
      item.currentNAV = item.currentNAV ? formatAmount(item.currentNAV) : "";
      return item;
    });
    return tabItem;
  }

  changeHandler = tabIndex => {
    let tabSelected = "";
    this.setState({ tabIndex }, () => {
      if (tabIndex.toString() === "1") {
        tabSelected = "My Investments";
        this.setState(
          { printData: this.state.OptionData.fundData.tab1 },
          () => {
            let tab = this.addUnitSymbols(
              this.state.printData,
              this.state.OptionData.accountType
            );
            this.setState({ exportData: tab });
          }
        );
      } else if (tabIndex.toString() === "2") {
        tabSelected = "Portfolio Solutions";
        this.setState(
          { printData: this.state.OptionData.fundData.tab2 },
          () => {
            let tab = this.addUnitSymbols(
              this.state.printData,
              this.state.OptionData.accountType
            );
            this.setState({ exportData: tab});
          }
        );
      } else if (tabIndex.toString() === "3") {
        tabSelected = "Portfolio Builders";
        this.setState(
          { printData: this.state.OptionData.fundData.tab3 },
          () => {
            let tab = this.addUnitSymbols(
              this.state.printData,
              this.state.OptionData.accountType
            );
            this.setState({ exportData: tab });
          }
        );
      } else {
        tabSelected = "Values-driven Investments";
        this.setState(
          { printData: this.state.OptionData.fundData.tab4 },
          () => {
            let tab = this.addUnitSymbols(
              this.state.printData,
              this.state.OptionData.accountType
            );
            this.setState({ exportData: tab });
          }
        );
      }
      this.checkEnableScroll(this.state.OptionData, tabIndex);
      initiateTracking("tabClick", this.getPageTitle(), "", tabSelected);
    });
  };

  findExpanded(index = "", expanded = false) {
    let { tabIndex, OptionData } = this.state;

    if (OptionData && OptionData.fundData && tabIndex) {
      let tab = `tab${tabIndex}`;
      OptionData.fundData[tab][index].isExpanded = expanded;
      this.forceUpdate();
    }
  }

  breadcrumbRoutes = () => {
    return [
      {
        routeName: "Home",
        path: "/"
      },
      {
        routeName: "Investments",
        path: "/investments"
      },
      {
        routeName: () => <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} page="IOD" property="field_page_title" defaultMessage="Investment option details" />,
        path: ""
      }
    ];
  }

  compareByAlph = (a, b) => {
    if (a > b) {
      return -1;
    }
    if (a < b) {
      return 1;
    }
    return 0;
  }

 exportView = (BtnId, exportPrintId)=>{
  return (
      <StyleLessButton id={BtnId}>
      <IconPadding>
        <img src={exportIcon} alt="export ico"/>
        <DataExportPrint id={exportPrintId} onClick={() => this.exportExcel()}>EXPORT</DataExportPrint>
      </IconPadding>
    </StyleLessButton>
  )}    
  getTabPanes = (OptionData) => {

    const tabPanes = [
      {
        title: "My Investments",
        key: 1,
        tooltipText: "",
        destComponent: "table",
        mobComponent: "table",
        options: "true",
        text: "You currently have no investments.",
        data: OptionData.fundData && OptionData.fundData.tab1,
        expandConfig: [
          {
            title: "",
            dataIndex: "investmentOption",
            key: "investmentOption",
            width: 215,
            render: (text, row, index) => {
              if (text === "Benchmark Return\n  ") {
                return <DivHeading data-test="heading"> {text}</DivHeading>;
              } else {
                let urlArray = this.modifyAnchorTag(row.url);
                if (row.url === "Benchmark Return")
                  return (
                    <UnderlyingFundParagraph data-test="headingWithOutAchor">{row.url}</UnderlyingFundParagraph>
                  );
                else {
                  let url = `${row.investmentPercentage} % ${urlArray[1]}`;
                  return (
                    <UnderlyingFund
                      data-test="headingWithAchor"
                      id="anrFund"
                      onClick={this.getAlert.bind(this, urlArray[0])}
                      dangerouslySetInnerHTML={{ __html: url }}
                    />
                  );
                }
              }
            }
          },
          {
            title: "",
            dataIndex: "currentBalance",
            key: "currentBalance",
            width: 199,
            render: value => {
              return value ? (
                <DataHeading data-test="heading">{formatAmount(value)}</DataHeading>
              ) : (
                <DataHeading data-test="heading"> &mdash; </DataHeading>
              );
            }
          },
          {
            title: "",
            dataIndex: "availableUnits",
            key: "availableUnits",
            width: 199,
            render: value => {
              return value ? (
                <DataHeading data-test="heading">{formatShares(value)}</DataHeading>
              ) : (
                <DataHeading data-test="heading"> &mdash; </DataHeading>
              );
            }
          },
          {
            title: "",
            dataIndex:
              OptionData.accountType === "Standard"
                ? "stdExpRatio"
                : "selExpRatio",
            key:
              OptionData.accountType === "Standard"
                ? "stdExpRatio"
                : "selExpRatio",
            width: 199,
            render: value => {
              return value ? (
                <DataHeading data-test="heading">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="heading"> &mdash; </DataHeading>
              );
            }
          },
          {
            title: "",
            dataIndex: "currentNAV",
            key: "currentNAV",
            width: 199,
            render: value => {
              return value ? (
                <DataHeading data-test="heading">{formatAmount(value)}</DataHeading>
              ) : (
                <DataHeading data-test="heading"> &mdash; </DataHeading>
              );
            }
          }
        ],
        columnConfig: [
          {
            title: () => (
              <div>
                Investment Option
              </div>
            ),
            dataIndex: "investmentOption",
            key: "investmentOption",
            render: value => {
              return <InvestmentOption data-test="columnval">{replaceSelect(value)}</InvestmentOption>;
            },
            width: 215,
            sortDirections: ["ascend", "descend"],
            sorter: (a, b) =>
              this.compareByAlph(a.investmentOption, b.investmentOption)
          },
          {
            title: () => (
              <div>
                Current Balance
              </div>
            ),
            dataIndex: "currentBalance",
            key: "currentBalance",
            render: value => {
              return value ? (
                <DataHeading data-test="columnval">{formatAmount(value)}</DataHeading>
              ) : (
                <DataHeading data-test="columnval"> &mdash; </DataHeading>
              );
            },
            width: 199,
            sortDirections: ["ascend", "descend"],
            sorter: (a, b) => a.currentBalance - b.currentBalance
          },
          {
            title: () => (
              <div>
                Available Units
              </div>
            ),
            dataIndex: "availableUnits",
            key: "availableUnits",
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="columnval">{formatShares(value)}</DataHeading>
              ) : (
                <DataHeading data-test="columnval"> &mdash; </DataHeading>
              );
            },
            width: 199,
            sortDirections: ["ascend", "descend"],
            sorter: (a, b) => a.availableUnits - b.availableUnits
          },
          {
            title: () => (
              <div>
                Expense Ratio
              </div>
            ),
            dataIndex: "selExpRatio",
            key: "selExpRatio",
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="columnval">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="columnval"> &mdash; </DataHeading>
              );
            },
            width: 199,
            sortDirections: ["ascend", "descend"],
            sorter: (a, b) => {
              let key = "selExpRatio";
              return a[key] - b[key];
            }
          },
          {
            title: () => (
              <div>
                Current NAV
              </div>
            ),
            dataIndex: "currentNAV",
            key: "currentNAV",
            render: (value,e,index) => {
              return value !== "" ? (
                <Tooltip data-test="columnval" placement="bottomLeft" title={moment(OptionData.fundData.tab1[index].date).format("LL")}><UnderlyingContent>{formatAmount(value)} </UnderlyingContent></Tooltip>
              ) : (
                <DataHeading> &mdash; </DataHeading>
              );
            },
            width: 199,
            sortDirections: ["ascend", "descend"],
            sorter: (a, b) => a.currentNAV - b.currentNAV
          }
        ]
      },
      {
        title: "Portfolio Solutions",
        key: 2,
        tooltipText:
          "Pre-allocated investments, rebalanced daily by seasoned professionals.",
        destComponent: "table",
        mobComponent: "table",
        options: "true",
        text:
          "No portfolio solutions present. Make your first investment to see the data here.",
        data: OptionData.fundData && OptionData.fundData.tab2,
        expandConfig: [
          {
            title: "",
            dataIndex: "investmentOption",
            key: "investmentOption",
            width: 212,
            render: (text, row, index) => {
              
              if (text === "Benchmark Return\n  ") {
                return <DivHeading data-test="heading"> {text}</DivHeading>;
              } else {
                let urlArray = this.modifyAnchorTag(row.url);
                if (row.url === "Benchmark Return")
                  return (
                    <UnderlyingFundParagraph data-test="headingWithOutAchor">{row.url}</UnderlyingFundParagraph>
                  );
                else {
                  let url = `${row.investmentPercentage} % ${urlArray[1]}`;
                  return (
                    <UnderlyingFund
                      data-test="headingWithAchor"
                      id="anrInvestmentOption"
                      onClick={this.getAlert.bind(this, urlArray[0])}
                      dangerouslySetInnerHTML={{ __html: url }}
                    />
                  );
                }
              }
            }
          },
          {
            title: "",
            dataIndex: "returnsYTD",
            key: "returnsYTD",
            width: 100,
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="heading">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="heading"> &mdash; </DataHeading>
              );
            }
          },
          {
            title: "",
            dataIndex: "oneY",
            key: "oneY",
            width: 100,
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="heading">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="heading"> &mdash; </DataHeading>
              );
            }
          },
          {
            title: "",
            dataIndex: "fiveY",
            key: "fiveY",
            width: 100,
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="heading">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="heading"> &mdash; </DataHeading>
              );
            }
          },
          {
            title: "",
            dataIndex: "tenY",
            key: "tenY",
            width: 100,
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="heading">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="heading"> &mdash; </DataHeading>
              );
            }
          },
          // Will be needed for future
          // {
          //   title: "",
          //   dataIndex: "stdExpRatio",
          //   key: "stdExpRatio",
          //   width: 100,
          //   className: OptionData.accountType !== "Standard" ? "" : "grey-item",
          //   render: value => {
          //     return value !== "" ? (
          //       <DataHeading data-test="heading">{value} %</DataHeading>
          //     ) : (
          //       <DataHeading data-test="heading"> &mdash; </DataHeading>
          //     );
          //   }
          // },
          {
            title: "",
            dataIndex: "selExpRatio",
            key: "selExpRatio",
            width: 120,
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="heading">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="heading"> &mdash; </DataHeading>
              );
            }
          },
          {
            title: "",
            dataIndex: "currentNAV",
            key: "currentNAV",
            width: 100,
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="heading">{formatAmount(value)}</DataHeading>
              ) : (
                <DataHeading data-test="heading"> &mdash; </DataHeading>
              );
            }
          }
        ],
        columnConfig: [
          {
            title: () => (
              <div>
                Investment Option
              </div>
            ),
            dataIndex: "investmentOption",
            key: "investmentOption",
            render: value => {
              return <InvestmentOption data-test="columnval">{replaceSelect(value)}</InvestmentOption>;
            },
            width: 215,
            sortDirections: ["ascend", "descend"],
            sorter: (a, b) =>
              this.compareByAlph(a.investmentOption, b.investmentOption)
          },
          {
            title: () => (
              <div>
                Returns Qtr
              </div>
            ),
            dataIndex: "returnsYTD",
            key: "returnsYTD",
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="columnval">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="columnval"> &mdash; </DataHeading>
              );
            },
            width: 101,
            sortDirections: ["ascend", "descend"],
            sorter: (a, b) => a.returnsYTD - b.returnsYTD
          },
          {
            title: () => <div>1 year</div>,
            dataIndex: "oneY",
            key: "oneY",
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="columnval">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="columnval"> &mdash; </DataHeading>
              );
            },
            width: 101,
            sortDirections: ["ascend", "descend"],
            sorter: (a, b) => a.oneY - b.oneY
          },
          {
            title: () => <div>5 year</div>,
            dataIndex: "fiveY",
            key: "fiveY",
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="columnval">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="columnval"> &mdash; </DataHeading>
              );
            },
            width: 101,
            sortDirections: ["ascend", "descend"],
            sorter: (a, b) => a.fiveY - b.fiveY
          },
          {
            title: () => <div>10 year</div>,
            dataIndex: "tenY",
            key: "tenY",
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="columnval">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="columnval"> &mdash; </DataHeading>
              );
            },
            width: 101,
            sortDirections: ["ascend", "descend"],
            sorter: (a, b) => a.tenY - b.tenY
          },
          // Will be needed for future
          // {
          //   title: () => (
          //     <div>
          //       Expense Ratio
          //       <br />
          //       (Standard)
          //     </div>
          //   ),
          //   dataIndex: "stdExpRatio",
          //   key: "stdExpRatio",
          //   className: OptionData.accountType !== "Standard" ? "" : "grey-item",
          //   render: value => {
          //     return value !== "" ? (
          //       <DataHeading data-test="columnval">{value} %</DataHeading>
          //     ) : (
          //       <DataHeading data-test="columnval"> &mdash; </DataHeading>
          //     );
          //   },
          //   width: 101,
          //   sortDirections: ["ascend", "descend"],
          //   sorter: (a, b) => a.stdExpRatio - b.stdExpRatio
          // },
          {
            title: () => (
              <div>
                Expense Ratio
              </div>
            ),
            dataIndex: "selExpRatio",
            key: "selExpRatio",
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="columnval">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="columnval"> &mdash; </DataHeading>
              );
            },
            width: 120,
            sortDirections: ["ascend", "descend"],
            sorter: (a, b) => a.selExpRatio - b.selExpRatio
          },
          {
            title: () => (
              <div>
                Current NAV
              </div>
            ),
            dataIndex: "currentNAV",
            key: "currentNAV",
            render: (value,e,index) => {
              return value !== "" ? (
                <Tooltip data-test="columnval" placement="bottomLeft" title={moment(OptionData.fundData.tab2[index].date).format("LL")}><UnderlyingContent>{formatAmount(value)} </UnderlyingContent></Tooltip>
              ) : (
                <DataHeading> &mdash; </DataHeading>
              );
            },
            width: 101,
            sortDirections: ["ascend", "descend"],
            sorter: (a, b) => a.currentNAV - b.currentNAV
          }
        ]
      },
      {
        title: "Portfolio Builders",
        key: 3,
        tooltipText:
          "Customized funds, driven by your giving timeline and goals.",
        destComponent: "table",
        mobComponent: "table",
        options: "true",
        text:
          "No portfolio builders present. Make your first investment to see the data here.",
        data: OptionData.fundData && OptionData.fundData.tab3,
        expandConfig: [
          {
            title: "",
            dataIndex: "investmentOption",
            key: "investmentOption",
            width: 212,
            render: (text, row, index) => {
              if (text === "Benchmark Return\n  ") {
                return <DivHeading data-test="heading"> {text}</DivHeading>;
              } else {
                let urlArray = this.modifyAnchorTag(row.url);
                if (row.url === "Benchmark Return")
                  return (
                    <UnderlyingFundParagraph data-test="headingWithOutAchor">{row.url}</UnderlyingFundParagraph>
                  );
                else {
                  let url = `${row.investmentPercentage} % ${urlArray[1]}`;
                  return (
                    <UnderlyingFund
                      data-test="headingWithAchor"
                      id="anrInvestment"
                      onClick={this.getAlert.bind(this, urlArray[0])}
                      dangerouslySetInnerHTML={{ __html: url }}
                    />
                  );
                }
              }
            }
          },
          {
            title: "",
            dataIndex: "returnsYTD",
            key: "returnsYTD",
            width: 100,
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="heading">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="heading"> &mdash; </DataHeading>
              );
            }
          },
          {
            title: "",
            dataIndex: "oneY",
            key: "oneY",
            width: 100,
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="heading">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="heading"> &mdash; </DataHeading>
              );
            }
          },
          {
            title: "",
            dataIndex: "fiveY",
            key: "fiveY",
            width: 100,
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="heading">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="heading"> &mdash; </DataHeading>
              );
            }
          },
          {
            title: "",
            dataIndex: "tenY",
            key: "tenY",
            width: 100,
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="heading">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="heading"> &mdash; </DataHeading>
              );
            }
          },
          // Will be needed for future
          // {
          //   title: "",
          //   dataIndex: "stdExpRatio",
          //   key: "stdExpRatio",
          //   className: OptionData.accountType !== "Standard" ? "" : "grey-item",
          //   width: 100,
          //   render: value => {
          //     return value !== "" ? (
          //       <DataHeading data-test="heading">{value} %</DataHeading>
          //     ) : (
          //       <DataHeading data-test="heading"> &mdash; </DataHeading>
          //     );
          //   }
          // },
          {
            title: "",
            dataIndex: "selExpRatio",
            key: "selExpRatio",
            width: 120,
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="heading">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="heading"> &mdash; </DataHeading>
              );
            }
          },
          {
            title: "",
            dataIndex: "currentNAV",
            key: "currentNAV",
            width: 100,
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="heading">{formatAmount(value)}</DataHeading>
              ) : (
                <DataHeading data-test="heading"> &mdash; </DataHeading>
              );
            }
          }
        ],
        columnConfig: [
          {
            title: () => (
              <div>
                Investment Option
              </div>
            ),
            dataIndex: "investmentOption",
            key: "investmentOption",
            render: value => {
              return <InvestmentOption data-test="columnval">{replaceSelect(value)}</InvestmentOption>;
            },
            width: 215,
            sortDirections: ["ascend", "descend"],
            sorter: (a, b) =>
              this.compareByAlph(a.investmentOption, b.investmentOption)
          },
          {
            title: () => (
              <div>
                Returns Qtr
              </div>
            ),
            dataIndex: "returnsYTD",
            key: "returnsYTD",
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="columnval">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="columnval"> &mdash; </DataHeading>
              );
            },
            width: 101,
            sortDirections: ["ascend", "descend"],
            sorter: (a, b) => a.returnsYTD - b.returnsYTD
          },
          {
            title: () => <div>1 year</div>,
            dataIndex: "oneY",
            key: "oneY",
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="columnval">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="columnval"> &mdash; </DataHeading>
              );
            },
            width: 101,
            sortDirections: ["ascend", "descend"],
            sorter: (a, b) => a.oneY - b.oneY
          },
          {
            title: () => <div>5 year</div>,
            dataIndex: "fiveY",
            key: "fiveY",
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="columnval">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="columnval"> &mdash; </DataHeading>
              );
            },
            width: 101,
            sortDirections: ["ascend", "descend"],
            sorter: (a, b) => a.fiveY - b.fiveY
          },
          {
            title: () => <div>10 year</div>,
            dataIndex: "tenY",
            key: "tenY",
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="columnval">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="columnval"> &mdash; </DataHeading>
              );
            },
            width: 101,
            sortDirections: ["ascend", "descend"],
            sorter: (a, b) => a.tenY - b.tenY
          },
          // Will be needed for future
          // {
          //   title: () => (
          //     <div>
          //       Expense
          //       <br />
          //       Ratio
          //       <br />
          //       (Standard)
          //     </div>
          //   ),
          //   dataIndex: "stdExpRatio",
          //   key: "stdExpRatio",
          //   className: OptionData.accountType !== "Standard" ? "" : "grey-item",
          //   render: value => {
          //     return value !== "" ? (
          //       <DataHeading data-test="columnval">{value} %</DataHeading>
          //     ) : (
          //       <DataHeading data-test="columnval"> &mdash; </DataHeading>
          //     );
          //   },
          //   width: 101,
          //   sortDirections: ["ascend", "descend"],
          //   sorter: (a, b) => a.stdExpRatio - b.stdExpRatio
          // },
          {
            title: () => (
              <div>
                Expense Ratio
              </div>
            ),
            dataIndex: "selExpRatio",
            key: "selExpRatio",
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="columnval">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="columnval"> &mdash; </DataHeading>
              );
            },
            width: 120,
            sortDirections: ["ascend", "descend"],
            sorter: (a, b) => a.selExpRatio - b.selExpRatio
          },
          {
            title: () => (
              <div>
                Current NAV
              </div>
            ),
            dataIndex: "currentNAV",
            key: "currentNAV",
            render:(value,e,index) => {
              return value !== "" ? (
                <Tooltip data-test="columnval" placement="bottomLeft" title={moment(OptionData.fundData.tab3[index].date).format("LL")}><UnderlyingContent>{formatAmount(value)} </UnderlyingContent></Tooltip>
              ) : (
                <DataHeading> &mdash; </DataHeading>
              );
            },
            width: 101,
            sortDirections: ["ascend", "descend"],
            sorter: (a, b) => a.currentNAV - b.currentNAV
          }
        ]
      },
      {
        title: "Values-driven Investments",
        key: 4,
        tooltipText: "Socially responsible investment options.",
        destComponent: "table",
        mobComponent: "table",
        options: "true",
        text:
          "No values-driven investments present. Make your first investment to see the data here.",
        data: OptionData.fundData && OptionData.fundData.tab4,
        expandConfig: [
          {
            title: "",
            dataIndex: "investmentOption",
            key: "investmentOption",
            width: 212,
            render: (text, row, index) => {
              if (text === "Benchmark Return\n  ") {
                return <DivHeading data-test="heading"> {text}</DivHeading>;
              } else {
                let urlArray = this.modifyAnchorTag(row.url);
                if (row.url === "Benchmark Return")
                  return (
                    <UnderlyingFundParagraph data-test="headingWithOutAchor">{row.url}</UnderlyingFundParagraph>
                  );
                else {
                  let url = `${row.investmentPercentage} % ${urlArray[1]}`;
                  return (
                    <UnderlyingFund 
                      id="anrInvest"
                      data-test="headingWithAchor"
                      onClick={this.getAlert.bind(this, urlArray[0])}
                      dangerouslySetInnerHTML={{ __html: url }}
                    />
                  );
                }
              }
            }
          },
          {
            title: "",
            dataIndex: "returnsYTD",
            key: "returnsYTD",
            width: 100,
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="heading">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="heading"> &mdash; </DataHeading>
              );
            }
          },
          {
            title: "",
            dataIndex: "oneY",
            key: "oneY",
            width: 100,
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="heading">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="heading"> &mdash; </DataHeading>
              );
            }
          },
          {
            title: "",
            dataIndex: "fiveY",
            key: "fiveY",
            width: 100,
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="heading">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="heading"> &mdash; </DataHeading>
              );
            }
          },
          {
            title: "",
            dataIndex: "tenY",
            key: "tenY",
            width: 100,
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="heading">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="heading"> &mdash; </DataHeading>
              );
            }
          },
          // Will be needed for future
          // {
          //   title: "",
          //   dataIndex: "stdExpRatio",
          //   key: "stdExpRatio",
          //   className: OptionData.accountType !== "Standard" ? "" : "grey-item",
          //   width: 100,
          //   render: value => {
          //     return value !== "" ? (
          //       <DataHeading data-test="heading">{value} %</DataHeading>
          //     ) : (
          //       <DataHeading data-test="heading"> &mdash; </DataHeading>
          //     );
          //   }
          // },
          {
            title: "",
            dataIndex: "selExpRatio",
            key: "selExpRatio",
            width: 120,
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="heading">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="heading"> &mdash; </DataHeading>
              );
            }
          },
          {
            title: "",
            dataIndex: "currentNAV",
            key: "currentNAV",
            width: 100,
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="heading">{formatAmount(value)}</DataHeading>
              ) : (
                <DataHeading data-test="heading"> &mdash; </DataHeading>
              );
            }
          }
        ],
        columnConfig: [
          {
            title: () => (
              <div>
                Investment Option
              </div>
            ),
            dataIndex: "investmentOption",
            key: "investmentOption",
            render: value => {
              return <InvestmentOption data-test="columnval">{replaceSelect(value)}</InvestmentOption>;
            },
            width: 215,
            sortDirections: ["ascend", "descend"],
            sorter: (a, b) =>
              this.compareByAlph(a.investmentOption, b.investmentOption)
          },
          {
            title: () => (
              <div>
                Returns Qtr
              </div>
            ),
            dataIndex: "returnsYTD",
            key: "returnsYTD",
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="columnval">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="columnval"> &mdash; </DataHeading>
              );
            },
            width: 101,
            sortDirections: ["ascend", "descend"],
            sorter: (a, b) => a.returnsYTD - b.returnsYTD
          },
          {
            title: () => <div>1 year</div>,
            dataIndex: "oneY",
            key: "oneY",
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="columnval">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="columnval"> &mdash; </DataHeading>
              );
            },
            width: 101,
            sortDirections: ["ascend", "descend"],
            sorter: (a, b) => a.oneY - b.oneY
          },
          {
            title: () => <div>5 year</div>,
            dataIndex: "fiveY",
            key: "fiveY",
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="columnval">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="columnval"> &mdash; </DataHeading>
              );
            },
            width: 101,
            sortDirections: ["ascend", "descend"],
            sorter: (a, b) => a.fiveY - b.fiveY
          },
          {
            title: () => <div>10 year</div>,
            dataIndex: "tenY",
            key: "tenY",
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="columnval">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="columnval"> &mdash; </DataHeading>
              );
            },
            width: 101,
            sortDirections: ["ascend", "descend"],
            sorter: (a, b) => a.tenY - b.tenY
          },
          // Will be needed for future
          // {
          //   title: () => (
          //     <div>
          //       Expense
          //       <br />
          //       Ratio
          //       <br />
          //       (Standard)
          //     </div>
          //   ),
          //   dataIndex: "stdExpRatio",
          //   key: "stdExpRatio",
          //   className: OptionData.accountType !== "Standard" ? "" : "grey-item",
          //   render: value => {
          //     return value !== "" ? (
          //       <DataHeading data-test="columnval">{value} %</DataHeading>
          //     ) : (
          //       <DataHeading data-test="columnval"> &mdash; </DataHeading>
          //     );
          //   },
          //   width: 101,
          //   sortDirections: ["ascend", "descend"],
          //   sorter: (a, b) => a.stdExpRatio - b.stdExpRatio
          // },
          {
            title: () => (
              <div>
                Expense Ratio
              </div>
            ),
            dataIndex: "selExpRatio",
            key: "selExpRatio",
            render: value => {
              return value !== "" ? (
                <DataHeading data-test="columnval">{value} %</DataHeading>
              ) : (
                <DataHeading data-test="columnval"> &mdash; </DataHeading>
              );
            },
            width: 120,
            sortDirections: ["ascend", "descend"],
            sorter: (a, b) => a.selExpRatio - b.selExpRatio
          },
          {
            title: () => (
              <div>
                Current NAV
              </div>
            ),
            dataIndex: "currentNAV",
            key: "currentNAV",
            render:(value,e,index)=> {
              return value !== "" ? (
                <Tooltip data-test="columnval" placement="bottomLeft" title={moment(OptionData.fundData.tab4[index].date).format("LL")}><UnderlyingContent>{formatAmount(value)} </UnderlyingContent></Tooltip>
              ) : (
                <DataHeading> &mdash; </DataHeading>
              );
            },
            width: 101,
            sortDirections: ["ascend", "descend"],
            sorter: (a, b) => a.currentNAV - b.currentNAV
          }
        ]
      }
    ];

    return tabPanes;

  }

  render() {

    if (this.state.isLoading) return <Preloader />;
    
    const { OptionData } = this.state;
    if (this.state.tabIndex.toString() === "1" && OptionData.fundData) {
      this.state.printData = OptionData.fundData.tab1;
      this.state.exportData = this.addUnitSymbols(
        this.state.printData,
        OptionData.accountType
      );
    }

    const tabPanes = this.getTabPanes(OptionData);

    const PrintText = props => {
      const tabIndex = props.tabIndex;
      return (
        <DataExportPrint>
          <a id="anrPrint"
            onClick={() => this.analyticsTracking('Print',tabIndex)}
          >
            {props.children}
          </a>
        </DataExportPrint>
      );
    };

    return (
      <ContentProvider types={[Types.PAGE_TITLE_DESCRIPTION]} pages={["IOD", "Performance Reports"]}>
        <div className="No-y-overflow investmentTableIod Analytics_investmentOptionDetails">
          {OptionData && (
            <FixedWidth>
              <BreadcrumbComponent breadcrumbRoutes={this.breadcrumbRoutes()} />
              <PagesHeading letterSpace="0.5px" >
                <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} page="IOD" property="field_page_title" defaultMessage="Investment option details" setTitle={this.setPageTitle} />
              </PagesHeading>
              <DataValue className="mt-10" isWordBreak>
                {OptionData.fundName} - {OptionData.fundId}
              </DataValue>
              <DataHeading className="mt-30 mb-50">                
                <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} page="IOD" html={true} property="description__value" defaultMessage="<p>This page shows you a holistic view of your investment option details, which include investment options, returns, historical NAV and more.</p>" />
              </DataHeading>
              <div>
                <IconsPlaceNew>
                  {this.state.tabIndex.toString() === "1" && (
                      this.exportView("btnExportMyInvestments", "anrExportMyInvestments")
                  )}
                  {this.state.tabIndex.toString() === "2" && (
                      this.exportView("btnExportPortSoln", "anrExportExportPortSoln")
                   )}
                  {this.state.tabIndex.toString() === "3" && (
                      this.exportView("btnExprtPrtBldrs", "anrExportPrtBldrs")
                   )}
                  {this.state.tabIndex.toString() === "4" && (
                    this.exportView("btnExprtValueInvstmnt", "anrExportValueInvstmnt")
                   )}

                  <PrintComponents
                    className="i_print"
                    trigger={
                      <StyleLessButton id="btnPrint">
                        <IconPadding className="ml2">
                          <img src={printIcon} alt="print ico"/>
                          <PrintText tabIndex = {this.state.tabIndex}>PRINT</PrintText>
                        </IconPadding>
                      </StyleLessButton>
                    }
                  >
                    <div>
                      {this.state.tabIndex.toString() === "1" ? (
                        <InvestmentOptionDetailsWeb
                          className="investment_print"
                          fundData={this.state.printData}
                          columnConfig={myInvestmentColumns}
                          print={true}
                          tabName={"My Investments"}
                          fundName={OptionData.fundName}
                          fundId={OptionData.fundId}
                        />
                      ) : (
                        <>
                          {this.state.tabIndex.toString() === "2" && (
                            <InvestmentOptionDetailsWeb
                              className="investment_print"
                              fundData={this.state.printData}
                              columnConfig={columns}
                              print={true}
                              tabName={"Portfolio Solutions"}
                              fundName={OptionData.fundName}
                              fundId={OptionData.fundId}
                            />
                          )}
                          {this.state.tabIndex.toString() === "3" && (
                            <InvestmentOptionDetailsWeb
                              className="investment_print"
                              fundData={this.state.printData}
                              columnConfig={columns}
                              print={true}
                              tabName={"Portfolio Builders"}
                              fundName={OptionData.fundName}
                              fundId={OptionData.fundId}
                            />
                          )}

                          {this.state.tabIndex.toString() === "4" && (
                            <InvestmentOptionDetailsWeb
                              className="investment_print"
                              fundData={this.state.printData}
                              columnConfig={columns}
                              print={true}
                              tabName={"Values-driven Investments"}
                              fundName={OptionData.fundName}
                              fundId={OptionData.fundId}
                            />
                          )}
                        </>
                      )}
                    </div>
                  </PrintComponents>
                </IconsPlaceNew>
              </div>
              {OptionData && OptionData !== -1 && OptionData.fundData ? (
                <TabsComponent
                  marginRight="0px"
                  tooltip={true}
                  getPageTitle={this.getPageTitle.bind(this)}
                  exportDataUpdate={this.exportDataUpdate.bind(this)}
                  findExpanded={this.findExpanded.bind(this)}
                  location={this.props.location}
                  activeKey={this.state.tabIndex}
                  tabPanes={tabPanes}
                  tabConfig={tabConfig}
                  yscrollC={false}
                  noBorder={true}
                  enableScroll={this.state.enableScroll}
                  getChange={this.changeHandler}
                  accountType={OptionData.accountType}
                />
              ) : (
                <Preloader />
              )}

              <div className="mt3">
                <SectionLastHeading>                  
                  <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} page="Performance Reports" property="field_page_title" defaultMessage="Past investment performance reports" />
                </SectionLastHeading>
                <Row className="mt3">
                  <PIPWrapper>
                    {this.props.quaterlyReport.map((item, index) => (
                      <Col key={index}>
                        <DisplayFlex>
                          <DataHead>
                            {`${"Quarterly Investment Report - "}${item.name}`}
                          </DataHead>
                          <IconsPlace>
                            <a 
                              id={"anrInvstmntPerfrmnc"+item.name}                            
                              href="javascript:void(0)"
                              onClick={() =>
                                window.open(                                
                                    item.field_investment_performance_rep,
                                  "_blank"
                                )
                              }
                            >
                              <img src={EyeIcon} alt="eyeIcon"/>
                            </a>
                            <DownloadIcon 
                              id={"anrDownload"+item.name}
                              download
                              href={                              
                                item.field_investment_performance_rep
                              }
                              target="_blank"
                            >
                              <ReportIcon type="download" />
                            </DownloadIcon>
                          </IconsPlace>
                        </DisplayFlex>
                      </Col>
                    ))}
                  </PIPWrapper>
                </Row>
              </div>
            </FixedWidth>
          )}
        </div>
      </ContentProvider>
    );
  }
}

const mapStateToProps = state => ({  
  ...investmentOptionDerivedStates(state.toJS())
   });

InvestmentOptionDetails.propTypes = {
  quaterlyReport: PropTypes.oneOfType([PropTypes.array,PropTypes.object]),
  accountID: PropTypes.string,
  investmentDrupal: PropTypes. PropTypes.oneOfType([PropTypes.array,PropTypes.object]),
  investmentUST:  PropTypes.oneOfType([PropTypes.array,PropTypes.object]),
  isLoadingDrupal: PropTypes.bool,
  isLoadingReport: PropTypes.bool,
  isLoadingUST: PropTypes.bool,
  isLoadingUnderlying: PropTypes.bool,
  isMyLoadingUST:  PropTypes.bool,
  myInvestmentUST:  PropTypes.oneOfType([PropTypes.array,PropTypes.object]),
  processedData: PropTypes.func,
  requestData:  PropTypes.func,
  underlyingDrupal:  PropTypes.oneOfType([PropTypes.array,PropTypes.object]),
}
const mapDispatchToProps = dispatch => ({
  requestData: data => dispatch(fetchInvestmentOptionData(data)),
  processedData: data => dispatch(processedDataFetch(data))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(InvestmentOptionDetails)
);
